/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

export default {
    ACTIVATE_title: "Activate your account",
    ACTIVATE_greeting: "Hello {0},",
    ACTIVATE_intro: "Set your password to access the Console.",
    ACTIVATE_password: "Password",
    ACTIVATE_passwordPlaceholder: "Your password",
    ACTIVATE_confirmPassword: "Confirm password",
    ACTIVATE_confirmPasswordPlaceholder: "Confirm your password",
    ACTIVATE_submit: "Activate my account",
    ACTIVATE_loading: "Loading…",
    ACTIVATE_mismatch: "Passwords do not match.",
    ACTIVATE_invalid: "This invitation is invalid or has already been used.",
    ACTIVATE_success: "Account activated",
    ACTIVATE_successMessage: "Your account is active. You can now sign in.",
    ACTIVATE_goToSignIn: "Sign in",

    PASSWORD_RULE_length: "Between 9 and 30 characters",
    PASSWORD_RULE_lower: "One lowercase letter",
    PASSWORD_RULE_upper: "One uppercase letter",
    PASSWORD_RULE_digit: "One digit"
};
